<template>
  <div class="container my-5">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <form @submit.prevent="register()">
          <div class="form-group">
            <label for="login">Login</label>
            <input
              type="text"
              class="form-control"
              id="login"
              v-model="login"
            />
          </div>
          <div class="form-group">
            <label for="password">Hasło</label>
            <input
              type="password"
              class="form-control"
              id="password"
              v-model="password"
            />
          </div>
          <div class="form-group">
            <label for="confirmPassword">Potwierdź hasło</label>
            <input
              type="password"
              class="form-control"
              id="confirmPassword"
              v-model="confirmPassword"
            />
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary">Wyślij</button>
          </div>
          <p v-if="isFailed" class="failed-warning">
            {{ failedText }}
          </p>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: "",
      password: "",
      confirmPassword: "",
      isFailed: false,
      failedText: "",
    };
  },
  methods: {
    register: function () {
      if (this.password !== this.confirmPassword) {
        this.isFailed = true;
        this.failedText = "Hasła nie pasują do siebie";
        return;
      }

      let data = { username: this.login, password: this.password };
      this.$api.register(data).then((data) => {
        if (data.ok) {
          this.goBack();
        }
      })
    },
  },
};
</script>